import React, { useState, useEffect } from 'react';


function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}


function Pubmed({ url: initialUrl, highlightText: initialText }) {
    const [url, setUrl] = useState(initialUrl);
    const [text, setText] = useState(initialText);

    const completeEncoded = (text) => {
        return encodeURIComponent(text).replace(/-/g, '%2D').replace(/,/g, '%2C').replace(/\.Abstract/g, '').replace(/\.\.Introduction/g, '').replace(/\.Background/g, '').replace(/\.\.Background/g, '').replace(/\.Abstract/g, '').replace(/\.\.Introduction/g, '');
    }
    const redirectAndHighlight = () => {
        let encodedText = completeEncoded(text)
        //     if (/^[!-*,-.\/:-@[-`{-~]/.test(firstWord)) {
        //        firstWord = firstWord.substring(1);
        //    }
        //    if (/^[!-*,-.\/:-@[-`{-~]$/.test(encodedText.slice(-1))) {
        //        encodedText = encodedText.slice(0, -1);
        //    }
        let firstThreeWords = encodedText.split('%20').slice(0, 3).join('%20');
        let lastTwoWords = encodedText.split('%20').slice(-2).join('%20')
        // eslint-disable-next-line
        firstThreeWords = firstThreeWords.replace(/^[!-*,-.\/:-@[-`{-~]+/, '').replace(/^\d+/, '');

        window.location.assign(url + "#:~:text=" + firstThreeWords + ',' + lastTwoWords);
    }
    useEffect(() => {
        setUrl(initialUrl);
        setText(initialText);
    }, [initialUrl, initialText]);


    // setTimeout(() => {
    //     redirectAndHighlight()
    // }, 500);
    // return (
    //     <div></div>
    // )
    useEffect(() => {
        waitForElm('.go-to-webpage').then((elm: any) => {
            elm.click();
        });
    }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <button className='go-to-webpage' style={{ marginTop: '20px', width: '80%', height: '80%', color: 'blue', borderRadius: '5px', border: 'none', padding: '10px 20px', cursor: 'pointer', fontSize: '1.5em' }} onClick={redirectAndHighlight}></button>
        </div>
    );
}
export default Pubmed;
